<rt-dialog-header [heading]="'rti.gfea.name' | translate">
  <div
    [innerHTML]="
      'rti.gfea.create_posting.modal.subtitle'
        | translate: { helpArticleUrl: GFEA_HELP_ARTICLE_URL }
    "
  ></div>
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  @if (postingForm) {
    <rti-gfea-posting-form
      [form]="postingForm"
      [posting]="dialogData.posting"
      [offer]="dialogData.offer"
      [selectableOffers]="suggestedOffers"
    />
  }
  <rti-error-messages-wrapper [errors]="errors" />
</rt-dialog-body>
<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button class="optional" variant="plain" (click)="remove()">
    {{ 'rti.job_boards.edit_posting.remove' | translate }}
  </rt-button>

  <rt-button variant="plain" (click)="close()">
    {{ 'rti.common.cancel' | translate }}
  </rt-button>

  <rt-button
    variant="primary"
    [disabled]="!formValid || !formDirty"
    [loading]="saving"
    (click)="save()"
  >
    {{ 'rti.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
